import {
  AbstractControl,
  Validators
} from '@angular/forms';
import { DateUtil } from './date.util';
import { LogService } from '../log/log.service';
import { Injectable } from '@angular/core';

@Injectable()
export class PioneerValidators {
  static LOG_SERVICE: LogService;

  static isInteger(formControl: AbstractControl): { [key: string]: boolean } | null {
    if (!formControl.value) {
      return null;
    }

    if (!Number.isInteger(formControl.value)) {
      return { 'not_integer': true };
    }

    return null;
  }

  static isValidCurrency(formControl: AbstractControl): { [key: string]: boolean } | null {
    // get the failure message from Validators.required instead
    if (Validators.required(formControl)) {
      return null;
    }

    // regular expression to match 1 to 8 digits, optionally followed by a decimal and up to 2 more digits
    const format = /^\d{1,8}(\.\d\d?)?$/;

    if (formControl.value <= 0 || !format.test(formControl.value)) {
      return { 'invalid_currency': true };
    }

    return null;
  }

  static isDate(formControl: AbstractControl): { [key: string]: boolean } | null {
    if (!formControl.value) {
      return null;
    }

    let isValid = false;
    try {
      let dateWrapper = DateUtil.parseDate(formControl.value);
      isValid = !isNaN(dateWrapper.getDate());
    } catch (error) {
      PioneerValidators.LOG_SERVICE.error(error);
      isValid = false;
    }

    if (!isValid) {
      return { 'date': true };
    }

    return null;
  }

  constructor(private logService: LogService) {
    PioneerValidators.LOG_SERVICE = logService;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/pioneer.validators.ts